module.exports = __webpack_public_path__ + "static/media/small-cross-ic.27ed8e7e.svg";